var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00CEBC",
    fillRule: "evenodd",
    d: "M13.726 11.528a7.55 7.55 0 0 0 1.14-4.006C14.866 3.368 11.538 0 7.433 0S0 3.368 0 7.522c0 4.155 3.328 7.522 7.433 7.522a7.37 7.37 0 0 0 5.374-2.325L18.137 17l.928-1.184zm-6.293 2.12c-3.343 0-6.053-2.743-6.053-6.126s2.71-6.125 6.053-6.125 6.053 2.742 6.053 6.125-2.71 6.125-6.053 6.125",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGreen);
export default __webpack_public_path__ + "static/media/searchGreen.fcae928ee5cf8dd02923a53be2ca6518.svg";
export { ForwardRef as ReactComponent };